<span class="tag flex border rounded-full px-2 items-center gap-1 justify-center mb-2"
        [ngClass]="[
            stateStyles[state || 'default'].border,
            stateStyles[state || 'default'].background,
            stateStyles[state || 'default'].text,
        ]"
>
    @if (showIcon) {
        <img [src]="assetUrl + 'icons/' + stateStyles[state].icon + '.svg'" alt="" aria-hidden="true">
    }
    {{ text }}
</span>